<nb-card>
  <nb-card-header i18n="@@ChooseCity">Выберите свой город</nb-card-header>
  <nb-card-body>
    <p class="small text-muted mb-2"><ng-container i18n="@@TotalAvailable">Всего доступно</ng-container>: {{ groups.length }}</p>

    <nb-form-field>
      <tui-icon nbPrefix icon="search"/>
      <input nbInput fullWidth type="text" [(ngModel)]="keyword" (ngModelChange)="applyFilter()"
             placeholder="Населенный пункт или город" i18n-placeholder="@@CityPlaceholder">
    </nb-form-field>

    <nb-list>
      @for (group of filtered; track group.id) {
        <nb-list-item [class.selected]="selectedGroup?.id === group.id" (click)="select(group)">
          {{ group.header }}
        </nb-list-item>
      }
    </nb-list>
  </nb-card-body>
</nb-card>
